<app-processing [visible]="!pageVars.isReady"></app-processing>
<app-email [(show)]="emailVars.showWindow" [toList]="emailVars.toList" [ccList]="emailVars.ccList" [subject]="emailVars.subject"></app-email>

<div class="flex col-12 justify-content-center">
  <p-card [style]="{ width: '95vw' }">
    <ng-template pTemplate="header">
      <p-breadcrumb [model]="pageVars.breadcrumbItems">
        <ng-template let-item let-last="last" let-first="first" pTemplate="item">
          <ng-container *ngIf="!first">
            <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
            <div *ngIf="!item.routerLink" class="breadcrumb-current-item">Order {{ formattedOrderNumber() }}</div>
          </ng-container>
        </ng-template>
      </p-breadcrumb>
    </ng-template>
    <div class="grid mb-2">
      <div class="col-3">
        <div class="flex flex-column">
          <div class="flex align-items-center justify-content-start mb-3">
            <p-floatlabel variant="on">
              <input type="text" id="ordersite" pInputText [(ngModel)]="siteLabel" style="min-width: 300px" disabled />
              <label for="ordersite">Site</label>
            </p-floatlabel>
          </div>
          <div class="flex align-items-center justify-content-start mb-3">
            <p-floatlabel variant="on" style="min-width: 300px">
              <p-treeselect
                inputId="locationId"
                [(ngModel)]="dialogVars.location"
                containerStyleClass="w-full"
                [options]="locationNodes"
                appendTo="body"
                [disabled]="!pageVars.isRequester && !this.canApprove()"
                (onNodeSelect)="onLocationChange()">
              </p-treeselect>
              <label for="locationId">Delivery Location</label>
            </p-floatlabel>
          </div>
          <div class="flex align-items-center justify-content-start mb-3">
            <p-floatlabel variant="on">
              <input
                type="text"
                id="ordername"
                pInputText
                [(ngModel)]="orderInfo.orderName"
                style="min-width: 300px"
                [disabled]="!pageVars.isRequester && !this.canApprove()" />
              <label for="ordername">Order Name</label>
            </p-floatlabel>
          </div>
          <div class="flex align-items-center justify-content-start">
            <button
              *ngIf="pageVars.isReady && (pageVars.isRequester || this.canApprove())"
              pButton
              label="Save"
              class="p-button"
              (click)="updateOrder()"></button>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="flex flex-column">
          <div class="flex align-items-center justify-content-start mb-3">
            <p-floatlabel variant="on">
              <input type="text" id="requester" pInputText [(ngModel)]="orderInfo.requester" style="min-width: 300px" disabled />
              <label for="requester">Requester</label>
            </p-floatlabel>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="flex flex-column">
          <app-address-book
            labelText="Alternate Owner(s) - Can Edit"
            (addressListChange)="onAlternateOwnersListChanged($event)"
            [addressList]="alternateOwnerUI"
            [excludeEmails]="[orderInfo.requester]"
            [disable]="pageVars.isRequester !== true && !this.canApprove()"></app-address-book>
          <app-address-book
            labelText="Delegate(s) - Email Only"
            (addressListChange)="onAddressListChanged($event)"
            [addressList]="selectedDelegates"
            [disable]="pageVars.isRequester !== true && !this.canApprove()"></app-address-book>
        </div>
      </div>
    </div>
    <!-- <div class="grid">
      <div class="col-3 justify-content-start">
        <button
          *ngIf="pageVars.isReady && (pageVars.isRequester || this.canApprove())"
          pButton
          label="Save"
          class="p-button"
          (click)="updateOrder()"></button>
      </div>
    </div> -->
    <hr />
    <div class="grid">
      <div class="col-7">
        <button *ngIf="isInsectOnlyVisible(orderStatus)" pButton label="Add Insect Only Item" class="p-button" (click)="openInsectModal()"></button>
        <button
          *ngIf="isSubstrateOnlyVisible(orderStatus)"
          pButton
          label="Add Substrate Only Item"
          class="p-button ml-1"
          (click)="openSubstrateModal()"></button>
        <button
          *ngIf="isInsectSubstrateVisible(orderStatus)"
          pButton
          label="Add Insects+Substrate Item"
          class="p-button ml-1"
          (click)="openInsectSubstrateModal()"></button>
      </div>
      <div class="col-5 flex justify-content-end">
        <button
          *ngIf="isOrderSubmitVisible(orderStatus)"
          pButton
          label="Submit"
          class="p-button ml-1"
          severity="success"
          (click)="setWorkflowStatus('Order', orderInfo.id, status.Orders.Submitted)"></button>
        <button
          *ngIf="isOrderItemInstanceSubmitVisible()"
          pButton
          label="Submit"
          class="p-button ml-1"
          severity="success"
          (click)="submitUpdatedInstances()"></button>
        <button *ngIf="isCopyOrderVisible()" pButton label="Copy Order" class="p-button ml-1" (click)="copyOrder()"></button>
        <button *ngIf="isOrderEmailVisible(orderStatus)" pButton label="Email Requester" class="p-button ml-1" (click)="orderEmail()"></button>
        <button
          *ngIf="isOrderApproveVisible(orderStatus)"
          pButton
          severity="success"
          label="Approve All"
          class="p-button ml-1"
          (click)="setWorkflowStatus('Order', orderInfo.id, status.Orders.Approved)"></button>
        <button
          *ngIf="isOrderDenyVisible(orderStatus)"
          pButton
          severity="danger"
          label="Deny All"
          class="p-button ml-1"
          (click)="setWorkflowStatus('Order', orderInfo.id, status.Orders.Denied)"></button>
      </div>
    </div>

    <p-table [value]="orderItems" dataKey="OrderItemSequence" [expandedRowKeys]="expandedRows">
      <ng-template #caption>
        <div class="flex flex-wrap justify-content-end gap-2"></div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th style="width: 5rem"></th>
          <th>Item ID</th>
          <th>Item Type</th>
          <th>Item Status</th>
          <th>Item Description</th>
          <th>Permit</th>
          <th>Container</th>
          <th>First Delivery Date</th>
          <th>Delivery Location</th>
          <th>No. of Occurrences</th>
          <th style="text-align: end">Actions</th>
        </tr>
      </ng-template>
      <ng-template #body let-item let-expanded="expanded">
        <tr>
          <td>
            <ng-container *ngIf="item.Instances?.length > 0">
              <p-button
                type="button"
                pRipple
                [pRowToggler]="item"
                [text]="true"
                [rounded]="true"
                [plain]="true"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
              </p-button>
            </ng-container>
          </td>
          <td>{{ item.OrderItemSequence }}</td>
          <td>{{ item.OrderItemTypeName }}</td>
          <td>{{ item.OrderItemStatus }}</td>
          <td>{{ item[itemDescName] }}</td>
          <td>{{ item.Permit }}</td>
          <td>{{ item.ContainerName }}</td>
          <td>
            {{ item.FirstDeliveryDate }}
            <i *ngIf="item.HasDeliveryDateIssue" class="fa-solid fa-triangle-exclamation" style="color: var(--res-color-orange-medium)"></i>
          </td>
          <td [pTooltip]="item.DeliveryLocation" tooltipPosition="top">
            <span>{{ item.DeliveryLocation?.split(',')?.slice(0, 3)?.join(', ') }}</span>
          </td>
          <td>{{ item.InstanceCount }}</td>
          <td style="text-align: end">
            <button
              *ngIf="isOrderItemEmailVisible(orderStatus, item.OrderItemStatus)"
              pButton
              pRipple
              type="button"
              icon="fa fa-envelope"
              text
              rounded
              severity="secondary"
              [outlined]="true"
              title="Email"
              (click)="orderItemEmail(item)"
              attr.data-testid="orderItemEmail{{ item.OrderItemId }}"></button>
            <button
              *ngIf="isOrderItemEditVisible(orderStatus, item.OrderItemStatus)"
              pButton
              pRipple
              type="button"
              title="Edit"
              icon="fa fa-pencil"
              text
              rounded
              severity="secondary"
              [outlined]="true"
              (click)="editOrderItem(item)"
              attr.data-testid="orderItemEdit{{ item.OrderItemId }}"></button>
            <button
              *ngIf="isOrderItemApproveVisible(orderStatus, item.OrderItemStatus)"
              pButton
              pRipple
              type="button"
              title="Approve"
              icon="fa fa-circle-check"
              text
              rounded
              severity="success"
              [outlined]="true"
              (click)="setWorkflowStatus('OrderItem', item.OrderItemId, status.Items.Approved)"
              attr.data-testid="orderItemApproved{{ item.OrderItemId }}"></button>
            <button
              *ngIf="isOrderItemDenyVisible(orderStatus, item.OrderItemStatus)"
              pButton
              pRipple
              type="button"
              title="Deny"
              icon="fa fa-circle-xmark"
              text
              rounded
              severity="danger"
              [outlined]="true"
              (click)="setWorkflowStatus('OrderItem', item.OrderItemId, status.Items.Denied)"
              attr.data-testid="orderItemDeny{{ item.OrderItemId }}"></button>
            <button
              *ngIf="isOrderItemCancelVisible(orderStatus, item.OrderItemStatus)"
              pButton
              pRipple
              type="button"
              title="Cancel"
              icon="fa fa-ban"
              text
              rounded
              severity="danger"
              [outlined]="true"
              (click)="setWorkflowStatus('OrderItem', item.OrderItemId, status.Items.Cancelled)"
              attr.data-testid="orderItemCancel{{ item.OrderItemId }}"></button>
            <button
              *ngIf="isOrderItemDeleteVisible(orderStatus, item.OrderItemStatus)"
              pButton
              pRipple
              type="button"
              title="Delete"
              icon="fa fa-trash-can"
              text
              rounded
              severity="danger"
              [outlined]="true"
              (click)="setWorkflowStatus('OrderItem', item.OrderItemId, status.Items.Deleted)"
              attr.data-testid="orderItemDelete{{ item.OrderItemId }}"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template #expandedrow let-item>
        <tr>
          <td colspan="10">
            <div style="margin-left: 5rem">
              <p-table [value]="item.Instances" dataKey="OrderItemSequence">
                <ng-template #header>
                  <tr>
                    <th *ngFor="let col of getColumns(item.OrderItemTypeName)">
                      {{ col.header }}
                    </th>
                    <th style="text-align: end">Actions</th>
                  </tr>
                </ng-template>
                <ng-template #body let-instance let-i="rowIndex">
                  <tr>
                    <td *ngFor="let col of getColumns(item.OrderItemTypeName)">
                      {{ col.field == 'SubstrateAmountUom' ? instance['SubstrateAmount'] + instance[col.field] : instance[col.field] }}
                    </td>
                    <td style="text-align: end">
                      <button
                        *ngIf="isOrderItemInstanceEditVisible(orderStatus, item, instance)"
                        pButton
                        pRipple
                        type="button"
                        title="Edit"
                        icon="fa fa-pencil"
                        text
                        rounded
                        severity="secondary"
                        [outlined]="true"
                        (click)="toggleEditPopover($event, instance.OrderItemInstanceId, item, i)"
                        attr.data-testid="orderItemInstanceEdit{{ instance.OrderItemInstanceId }}"></button>
                      <button
                        *ngIf="isOrderItemInstanceApproveVisible(orderStatus, item.OrderItemStatus, instance.OrderItemInstanceStatus)"
                        pButton
                        pRipple
                        type="button"
                        title="Approve"
                        icon="fa fa-circle-check"
                        text
                        rounded
                        severity="success"
                        [outlined]="true"
                        (click)="setWorkflowStatus('OrderItemInstance', instance.OrderItemInstanceId, status.Instances.Approved)"
                        attr.data-testid="orderItemInstanceApproved{{ item.OrderItemInstanceId }}"></button>
                      <button
                        *ngIf="isOrderItemInstanceDenyVisible(orderStatus, item.OrderItemStatus, instance.OrderItemInstanceStatus)"
                        pButton
                        pRipple
                        type="button"
                        title="Deny"
                        icon="fa fa-circle-xmark"
                        text
                        rounded
                        severity="danger"
                        [outlined]="true"
                        (click)="setWorkflowStatus('OrderItemInstance', instance.OrderItemInstanceId, status.Instances.Denied)"
                        attr.data-testid="orderItemInstanceDeny{{ item.OrderItemInstanceId }}"></button>
                      <button
                        *ngIf="isOrderItemInstanceCancelVisible(orderStatus, item.OrderItemStatus, instance.OrderItemInstanceStatus)"
                        pButton
                        pRipple
                        type="button"
                        title="Cancel"
                        icon="fa fa-ban"
                        text
                        rounded
                        severity="danger"
                        [outlined]="true"
                        (click)="toggleCancelPopover($event, instance.OrderItemInstanceId)"
                        attr.data-testid="orderItemInstanceCancel{{ instance.OrderItemInstanceId }}"></button>
                      <button
                        *ngIf="isOrderItemInstanceDeleteVisible(orderStatus, item, instance.OrderItemInstanceStatus)"
                        pButton
                        pRipple
                        type="button"
                        title="Delete"
                        icon="fa fa-trash-can"
                        text
                        rounded
                        severity="danger"
                        [outlined]="true"
                        (click)="setWorkflowStatus('OrderItemInstance', instance.OrderItemInstanceId, status.Instances.Deleted)"
                        attr.data-testid="orderItemInstanceDelete{{ item.OrderItemInstanceId }}"></button>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td [attr.colspan]="getColumns(item.OrderItemTypeName).length + 1">There are no order item instance for this product yet.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>

<p-dialog
  *ngIf="showInsectModal && orderInfo && orderInfo.catalogId"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showInsectModal"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '60rem' }">
  <app-order-insect
    [orderId]="orderInfo.id"
    [catalogId]="orderInfo.catalogId"
    [locationId]="orderInfo.deliveryLocationId"
    [profile]="pageVars.profile"
    [projects]="projects"
    [catalogInformation]="catalogInformation"
    [editingOrderItemDetails]="selectedOrderItem"
    [editing]="editing"
    [editingInstance]="editingInstance"
    [editingMode]="editingMode"
    [locationNodes]="locationNodes"
    [canApprove]="this.permissions.insectaryApproveOrders"
    [selectedOrderInstance]="selectedEditInstance"
    [status]="editingStatusInstances"
    [modalTitle]="modalTitle"
    [projectTooltipText]="projectTooltipText"
    (dialogCloseEvent)="onDialogCloseInsect()"
    (dialogCancelEvent)="onDialogCancelInsect()"></app-order-insect>
</p-dialog>

<p-dialog
  *ngIf="showSubstrateModal && orderInfo && orderInfo.catalogId"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showSubstrateModal"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '30rem' }">
  <app-order-substrate
    [orderId]="orderInfo.id"
    [catalogId]="orderInfo.catalogId"
    [locationId]="orderInfo.deliveryLocationId"
    [editingOrderItemDetails]="selectedOrderItem"
    [editing]="editing"
    [profile]="pageVars.profile"
    [projects]="projects"
    [catalogInformation]="catalogInformation"
    [editingInstance]="editingInstance"
    [editingMode]="editingMode"
    [canApprove]="this.permissions.insectaryApproveOrders"
    [selectedOrderInstance]="this.selectedEditInstance"
    [status]="editingStatusInstances"
    [modalTitle]="modalTitle"
    [locationNodes]="locationNodes"
    [projectTooltipText]="projectTooltipText"
    (dialogCloseEvent)="onDialogCloseSubstrate()"
    (dialogCancelEvent)="onDialogCancelSubstrate()">
  </app-order-substrate>
</p-dialog>

<p-dialog
  *ngIf="showInsectSubstrateModal && orderInfo && orderInfo.catalogId"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showInsectSubstrateModal"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '60rem' }">
  <app-order-insect-substrate
    [orderId]="orderInfo.id"
    [catalogId]="orderInfo.catalogId"
    [locationId]="orderInfo.deliveryLocationId"
    [profile]="pageVars.profile"
    [projects]="projects"
    [catalogInformation]="catalogInformation"
    [editingOrderItemDetails]="selectedOrderItem"
    [editing]="editing"
    [editingInstance]="editingInstance"
    [editingMode]="editingMode"
    [locationNodes]="locationNodes"
    [canApprove]="this.permissions.insectaryApproveOrders"
    [selectedOrderInstance]="selectedEditInstance"
    [status]="editingStatusInstances"
    [modalTitle]="modalTitle"
    [projectTooltipText]="projectTooltipText"
    (dialogCloseEvent)="onDialogCloseInsectSubstrate()"
    (dialogCancelEvent)="onDialogCancelInsectSubstrate()">
  </app-order-insect-substrate>
</p-dialog>

<p-popover #cancelPopover>
  <div class="flex flex-column gap-1">
    <div class="flex">
      <span class="flex font-medium block">
        <strong>Cancel Options</strong>
      </span>
    </div>
    <div class="flex w-full">
      <button
        pButton
        pRipple
        type="button"
        class="w-full justify-content-start"
        label="This instance"
        (click)="setOrderItemInstanceCancel()"></button>
    </div>
    <div class="flex w-full">
      <button
        pButton
        pRipple
        type="button"
        class="w-full justify-content-start"
        label="This and all following instances"
        (click)="setOrderItemInstanceFollowingCancel()"></button>
    </div>
  </div>
</p-popover>
<p-popover #editPopover>
  <div class="flex flex-column gap-1">
    <div class="flex">
      <span class="flex font-medium block">
        <strong>Edit Options</strong>
      </span>
    </div>
    <div class="flex w-full">
      <button
        pButton
        pRipple
        type="button"
        class="w-full justify-content-start"
        label="This instance"
        (click)="editOrderItemInstance(instance, 'single')"></button>
    </div>
    <div class="flex w-full">
      <button
        pButton
        pRipple
        type="button"
        class="w-full justify-content-start"
        label="This and all following instances"
        [disabled]="isLastInstance"
        (click)="editOrderItemInstance(instance, 'future')"></button>
    </div>
  </div>
</p-popover>
<app-submit-updated-dialog [(visible)]="showSubmitUpdatedDialog" (decision)="onSubmitUpdatedDialogDecision($event)"></app-submit-updated-dialog>
